import React, { useState , useEffect} from "react";
import styled from "@emotion/styled";
import { FaChevronDown } from "react-icons/fa";
import EventDetails from "../EventDetails";
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  width: 100%;
  max-width: 900px;
`;

const RequestCard = styled.div`
  background: #f5f5f5;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const EventInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const Actions = styled.div`
  display: flex;
  gap: 10px;

   @media (max-width: 768px) {
    display:flex;
    flex-direction:column;
  }
`;

const Button = styled.button`
  padding: 10px;
  border: none;
  border-radius: 4px;
  color: white;
  background-color: ${(props) => props.bg || "#385963"};
  cursor: pointer;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    margin-left: 5px;
    font-size: 10px;
    padding:5px;
    justify-content: center;
    text-align: center;      
  }
`;

const CollapsibleContent = styled.div`
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #ddd;
`;

const CommentBox = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  resize: vertical;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const SubmitCommentBtn = styled.button`
  margin-top: 0.5rem;
  padding: 10px 20px;
//   background-color: #ff9800;
background-color: #385963;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

const CommentSection = styled.div`
  display:flex;
  flex-direction:column;
  gap: 10px;
  margin-top: 10px;

   @media (max-width: 768px) {
    font-size: 14px;
    align-items:center;
    text-align:center;
    justify-content:center;
  }
`;



const MOCK_EVENTS = [
  {
    id: "01958bc7-27bf-783b-b105-3bcb19c0a7eb",
    categoryId: "01958bc0-00c5-7798-a9d9-70558e11586b",
    categoryName: { gr: "Πολιτιστικά Δρώμενα", en: "Cultural Events" },
    description: {
      gr: "Ανακαλύψτε τη χαλάρωση μέσα από τη βραδιά αρωματοθεραπείας...",
      en: "Discover relaxation through an aromatherapy evening...",
    },
    email: "info@olympusspa.gr",
    endDate: "2025-04-01T21:00:00Z",
    fileNames: [],
    location: { longitude: 22.5056, latitude: 40.1002 },
    name: { gr: "Βραδιά Χαλάρωσης και Αρωματοθεραπείας", en: "Aromatherapy Relaxation Night" },
    phone: "+30 23520 81234",
    providerName: "NIKOLETTA GKOULI",
    siteLink: "http://www.olympusspa.gr",
    startDate: "2025-04-01T18:00:00Z",
    status: 1,
  },
];


// FilePlaceTypeEnum
const request_status = {
   Pending :0 ,
   Approved: 1,
   Rejected: 2,
   ForRevision:3

};


const EventRequests = () => {
  const tokenString = sessionStorage.getItem("token");
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [expandedEventId, setExpandedEventId] = useState(null);
  const [comments, setComments] = useState({});
  const [loading, setLoading] = useState(false);
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const [events, setEvents] = useState([]);


  const formatDateTime = (isoString) =>
    new Date(isoString).toLocaleString(selectedLanguage, {
      dateStyle: "medium",
      timeStyle: "short",
    });

  const toggleExpand = (id) => {
    setExpandedEventId((prevId) => (prevId === id ? null : id));
  };


useEffect(() => {
  
const fetchPendingRequests = async () => {
  setLoading(true);
  try {
    const res = await fetch(`${BASE_URL}Event/search`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenString}`,
      },
      body: JSON.stringify({
        status: request_status.Pending,
      }),
    });

    if (!res.ok) {
      throw new Error("Failed to fetch pending events.");
    }

    const data = await res.json();
    setEvents(data);
  } catch (error) {
    alert("Error loading pending requests: " + error.message);
    console.error(error);
  } finally {
    setLoading(false);
  }
};
 
  fetchPendingRequests();
}, []);


  const handleCommentChange = (eventId, value) => {
    setComments((prev) => ({ ...prev, [eventId]: value }));
  };

   const submitComment = async (eventId) => {
    const comment = comments[eventId];
    if (!comment || comment.trim() === "") {
      alert("Please enter a comment before submitting.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}Event/${eventId}/updateStatus`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`,
        },
        body: JSON.stringify({
          newStatus: request_status.ForRevision,
          comment: comment,
        }),
      });

      if (!res.ok) {
        throw new Error("Failed to update event status");
      }

      alert("Comment submitted and status updated to 'For Revision'");
      // Optionally clear comment or collapse
      setComments((prev) => ({ ...prev, [eventId]: "" }));
      setExpandedEventId(null);

       setEvents(prev => prev.filter(event => event.id !== eventId));
    } catch (error) {
      alert("Error submitting comment: " + error.message);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

const rejectRequest = async (eventId) => {
  const comment = comments[eventId];
  // if (!comment || comment.trim() === "") {
  //   alert("Please enter a comment before rejecting.");
  //   return;
  // }

  setLoading(true);
  try {
    const res = await fetch(`${BASE_URL}Event/${eventId}/updateStatus`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
         Authorization: `Bearer ${tokenString}`,
      },
      body: JSON.stringify({
        newStatus: request_status.Rejected,
        comment: "rejected by admin",
      }),
    });

    if (!res.ok) {
      throw new Error("Failed to reject event");
    }

    alert("event rejected with comment.");
    setComments((prev) => ({ ...prev, [eventId]: "" }));
    setExpandedEventId(null);
     setEvents(prev => prev.filter(event => event.id !== eventId));
  } catch (error) {
    alert("Error rejecting event: " + error.message);
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  const approveRequest = async (eventId) => {
  setLoading(true);
  try {
    const res = await fetch(`${BASE_URL}Event/${eventId}/updateStatus`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenString}`, 
      },
      body: JSON.stringify({
        newStatus: request_status.Approved,
        comment: "Approved by admin",
      }),
    });

    if (!res.ok) {
      throw new Error("Failed to approve event");
    }

    alert("event approved successfully.");
    setExpandedEventId(null);
     setEvents(prev => prev.filter(event => event.id !== eventId));
  } catch (error) {
    alert("Error approving event: " + error.message);
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  return (
    <Container>
      {/* {events.length === 0 ? ( */}
      {!Array.isArray(events) || events.length === 0 ? (
        <p> {t('noPendingEventRequests')}</p>
      ) : (
        events.map((event) => (
          <RequestCard key={event.id}>
            <HeaderRow>
              <EventInfo>
                <div>
                  <strong>{event.name[selectedLanguage]}</strong>
                </div>
                <div>
                  {formatDateTime(event.startDate)} - {formatDateTime(event.endDate)}
                </div>
                 <div>
                  {event.providerName}
                </div>
              </EventInfo>
              <Actions>
                <Button
                  bg="#4CAF50"
                  onClick={() => approveRequest(event.id)}
               >
                   {t("approve")}
                </Button>
                 <Button bg="#d9534f" onClick={() => rejectRequest(event.id)}>
                  {t("reject")}
                </Button>
                <Button bg="#385963" onClick={() => toggleExpand(event.id)}>
                  {t("details")}
                  <FaChevronDown
                    style={{
                      marginLeft: "8px",
                      transition: "transform 0.3s",
                      transform:
                        expandedEventId === event.id ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                </Button>
              </Actions>
            </HeaderRow>

            {expandedEventId === event.id && (
              <CollapsibleContent>
                <EventDetails event={event} />

                {/* Admin comment section */}
                <CommentSection>
                  <label htmlFor={`comment-${event.id}`}>
                    <strong>  {t('addCommentForRevision')}:</strong>
                  </label>
                  <CommentBox
                    id={`comment-${event.id}`}
                    value={comments[event.id] || ""}
                    onChange={(e) => handleCommentChange(event.id, e.target.value)}
                    placeholder={i18n.t('writeCommentHere')}
                    disabled={loading}
                  />
                  <SubmitCommentBtn
                    onClick={() => submitComment(event.id)}
                    disabled={loading}
                  >
                    {t('submitCommentRequestRevision')}
                  </SubmitCommentBtn>
                </CommentSection>
              </CollapsibleContent>
            )}
          </RequestCard>
        ))
      )}
    </Container>
  );
};

export default EventRequests;
